import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState, useEffect } from "react";
import { baseURL } from "../../utils/constants";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

interface IProps {
  handleFile(file: any | null): void;
  archive?: string;
}

export const ArchiveUploader = ({ handleFile, archive }: IProps) => {
  const inputFile = useRef<HTMLInputElement>(null);
  const [localArchive, setLocalArchive] = useState<File | string | null>(null);

  useEffect(() => {
    if (archive && typeof archive === "string") {
      setLocalArchive(archive);
    }
  }, [archive]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = e.target.files?.[0];
    if (!fileUploaded) return;

    if (fileUploaded.size > 15000000) {
      Swal.fire({
        icon: "error",
        text: "Archivo demasiado grande, asegúrese de subir uno menor a 15MB",
      });
      return;
    }

    setLocalArchive(fileUploaded); // sólo uno se guarda
    handleFile(fileUploaded);
  };

  const handleRemove = () => {
    setLocalArchive(null);
    handleFile(null);
  };

  return (
    <div>
      <input
        type="text"
        className="form-control input"
        placeholder="Suba su archivo"
        style={{ cursor: "pointer" }}
        readOnly
        onClick={() => inputFile.current?.click()}
      />
      <input
        type="file"
        ref={inputFile}
        style={{ display: "none" }}
        id="file"
        accept=".pdf,.doc"
        onChange={handleChange}
      />

      {localArchive && typeof localArchive === "string" && (
        <div className=" d-flex justify-content-between align-items-center">
          <a
            href={baseURL + localArchive}
            download
            target="_blank"
            rel="noreferrer"
          >
            {localArchive.split("documents")[1]}
          </a>
          <button onClick={handleRemove} className="btn btn-danger btn-sm ml-2">
            Eliminar
          </button>
        </div>
      )}

      {localArchive && typeof localArchive !== "string" && (
        <div className="d-flex mt-2 justify-content-between align-items-center">
          <div>
            <FontAwesomeIcon icon={faCheck} />
            <span className="ml-1">{(localArchive as File).name}</span>
          </div>
          <button onClick={handleRemove} className="btn btn-danger btn-sm ml-2">
            Eliminar
          </button>
        </div>
      )}
    </div>
  );
};
